import { Badge, type Column, fmt } from "@nabble/ui";
import type { DataRequest } from "../../../../api/dataRequests";
import { KIND_LABEL, STATUS_LABEL, STATUS_TONE } from "../../../../model/dataRequests";
import { AnswerCell } from "./AnswerCell";
import { answerText } from "./answerText";

/** Columns of the person's data requests table. */
export const DATA_REQUEST_COLUMNS: Column<DataRequest>[] = [
  {
    key: "kind",
    label: "Request",
    minWidth: 200,
    text: (r) => KIND_LABEL[r.kind],
    render: (r) => (
      <div className="nb-cell-stack">
        <strong>{KIND_LABEL[r.kind]}</strong>
        {r.details ? (
          <span className="nb-cell-sub" title={r.details}>
            {r.details}
          </span>
        ) : null}
      </div>
    ),
  },
  {
    key: "status",
    label: "Status",
    width: 130,
    text: (r) => STATUS_LABEL[r.status],
    render: (r) => <Badge label={STATUS_LABEL[r.status]} tone={STATUS_TONE[r.status]} />,
  },
  { key: "createdAt", label: "Sent", type: "date", width: 130, text: (r) => fmt.date(r.createdAt) },
  {
    key: "answer",
    label: "Answer",
    minWidth: 220,
    wrap: true,
    sortable: false,
    text: (r) => answerText(r),
    render: (r) => <AnswerCell request={r} />,
  },
];
